// ==============================|| DEFAULT THEME - CUSTOM SHADOWS  ||============================== //

const CustomShadows = (theme) => ({
  button: `0 2px #0000000b`,
  text: `0 -1px 0 rgb(0 0 0 / 12%)`,
  z1: `0px 2px 8px ${theme.palette.grey.A200}`,
  z8: `0px 8px 16px ${theme.palette.grey.A200}`,
  z12: `0px 12px 24px ${theme.palette.grey.A200}`,
  z16: `0px 16px 32px ${theme.palette.grey.A200}`,
  z20: `0px 20px 40px ${theme.palette.grey.A200}`,
  z24: `0px 24px 48px ${theme.palette.grey.A200}`,
  primary: `0 4px 8px 0 ${theme.palette.primary.main}40`,
  primaryButton: `0 4px 8px 0 ${theme.palette.primary.main}40`,
  secondary: `0 4px 8px 0 ${theme.palette.secondary.main}40`,
  secondaryButton: `0 4px 8px 0 ${theme.palette.secondary.main}40`,
  error: `0 4px 8px 0 ${theme.palette.error.main}40`,
  errorButton: `0 4px 8px 0 ${theme.palette.error.main}40`,
  warning: `0 4px 8px 0 ${theme.palette.warning.main}40`,
  warningButton: `0 4px 8px 0 ${theme.palette.warning.main}40`,
  info: `0 4px 8px 0 ${theme.palette.info.main}40`,
  infoButton: `0 4px 8px 0 ${theme.palette.info.main}40`,
  success: `0 4px 8px 0 ${theme.palette.success.main}40`,
  successButton: `0 4px 8px 0 ${theme.palette.success.main}40`,
  grey: `0 4px 8px 0 ${theme.palette.grey[400]}40`,
  greyButton: `0 4px 8px 0 ${theme.palette.grey[400]}40`
});

export default CustomShadows;